module.exports = __webpack_public_path__ + "img/base.518e4b16.png";